import { default as AsyncFormPostModule } from "./asyncFormPost-module";

export default AsyncFormPostModule;
